import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useDeviceSettingsStore = defineStore('deviceSettings', () => {
    const pushNotificationsEnabled = ref<boolean>(false)

    return {
        pushNotificationsEnabled,
    }
})
